import React from "react";
import { useInternMode } from "./mode";

/**
 * Der Schalter in der Navbar (docs/02-konzept.md §8.1).
 *
 * NUR ZWEI ZUSTAENDE, seit die zweite Anmeldestufe weg ist: entweder der
 * Schalter steht da („yes"), oder es steht gar nichts da. Hier stand einmal
 * ein dritter Knopf, „Als Geschaeftsstelle anmelden", fuer Konten in
 * lwzo-admin ohne Staff-ACR. Den Fall gibt es nicht mehr: der IdP zwingt
 * lwzo-admin bei jedem Login auf zwei Faktoren und legt die Staff-ACR selbst
 * ins Token (src/idp/config/bsr_config.prototxt, user_minimum_acr_policy).
 * Wer angemeldet ist und die ACR trotzdem nicht hat, hat ein Token von VOR
 * der Umstellung („stale" in mode.tsx) — das erklaert /admin, nicht die
 * oeffentliche Navigationsleiste.
 */
export function InternSwitch() {
  const mode = useInternMode();

  // Alles ausser "yes" bekommt in der Navbar nichts: die Navbar ist die
  // oeffentliche Seite, und ein Knopf, den fast niemand benutzen darf, gehoert
  // dort nicht hin. Den Weg hinein gibt es ueber /admin (AdminPage), wo jemand
  // ihn absichtlich gesucht hat.
  if (mode.availability !== "yes") {
    return null;
  }

  // HIER STAND DER EINZIGE LINK AUF /admin IM GANZEN FRONTEND, und er hing an
  // `mode.active`: Admin-Modus aus, kein Einstieg in den Admin-Bereich —
  // obwohl /admin ausdruecklich NICHT am Admin-Modus haengt (App.tsx). Er
  // steht jetzt als eigener Link „Admin" neben dem Benutzernamen
  // (components/Navbar.tsx, AccountNav), auf dem Handy wie am Desktop, und
  // ueberlebt jedes Umschalten. Was hier bleibt, ist der Schalter selbst — er
  // ist eine Eigenschaft der Sitzung, kein Ort.
  return (
    <button
      type="button"
      className={
        "btn btn-sm " + (mode.active ? "btn-warning" : "btn-outline-secondary")
      }
      data-testid="intern-switch"
      aria-pressed={mode.active}
      onClick={mode.toggle}
    >
      Admin-Modus {mode.active ? "an" : "aus"}
    </button>
  );
}
